import { z } from '@campai/lib-common/utils/zod'

const optionalString = () => z.string().default('')
const optionalUrl = () => z.union([z.literal(''), z.url()]).default('')

export const AppEnvSchema = z.object({
    VITE_PRODUCT_KEY: z.enum(['campai', 'wunderpass']),
    VITE_PRODUCT_ENV: z.enum(['development', 'production']),
    VITE_PRODUCT_NAME: z.string().min(1),
    VITE_PRODUCT_ENDPOINT: z.url(),
    VITE_PRODUCT_DOCUMENTATION_URL: optionalUrl(),
    VITE_PRODUCT_CAMPAI_WEBSITE_URL: z.url(),
    VITE_PRODUCT_URL_OLD: optionalUrl(),
    VITE_PRODUCT_URL_ROOT: z.url(),
    VITE_PRODUCT_URL_ADMIN: z.url(),
    VITE_PRODUCT_URL_SYSTEM: z.url(),
    VITE_PRODUCT_URL_PORTAL: z.url(),
    VITE_PRODUCT_URL_EMBEDDABLE: z.url(),
    VITE_PRODUCT_URL_CONNECT: z.url(),
    VITE_PRODUCT_CURRENCY: z.enum(['EUR', 'USD']),

    VITE_SERVER_TZ: z.string().min(1),
    VITE_UNSUBSCRIBED_ORG_LIFETIME_DAYS: z.string().min(1),
    VITE_INTERCOM_APP_ID: optionalString(),

    VITE_AUTH_PROVIDER: z.enum(['blueid', 'authy']),

    VITE_BLUEID_ISSUER: optionalUrl(),
    VITE_BLUEID_CLIENTID: optionalString(),
    VITE_BLUEID_CLIENTID_MOBILE: optionalString(),

    VITE_AUTHY_ISSUER_URL: optionalUrl(),
    VITE_AUTHY_ISSUER_SECURITY_URL: optionalUrl(),
    VITE_AUTHY_CLIENTID: optionalString(),
    VITE_AUTHY_CLIENTID_MOBILE: optionalString(),

    VITE_EXPRESSA_APP_URL: z.url(),
    VITE_EXPRESSA_WORKSPACESHORTID: z.string().min(1),

    VITE_GET_STREAM_APP_KEY: optionalString(),
    VITE_GIPHY_API_KEY: z.string().min(1),
    VITE_MAPBOX_TOKEN: z.string().min(1),
    VITE_STRIPE_CONNECT_PK: optionalString(),
    VITE_WEB_PUSH_PUBLIC_KEY: optionalString(),
    VITE_HCAPTCHA_SITE_KEY: optionalString(),

    VITE_NATIVE_APP_BUILD: z.enum(['0', '1']).default('0'),
    VITE_PRODUCT_VERSION: optionalString(),
    VITE_PRODUCT_RELEASE: optionalString(),
    VITE_PRODUCT_RELEASE_TIME: optionalString(),
    VITE_SENTRY_DSN_WEB: optionalUrl(),
    VITE_SENTRY_DSN_MOBILE: optionalUrl(),
})

export type AppEnv = z.infer<typeof AppEnvSchema>
